import { TGetCompanyMembersResponse } from '@commenda/types/src/company/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useAccountingFirmMembers(caFirmId: string) {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TGetCompanyMembersResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `caFirm/${caFirmId}/members`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
